import qs from 'qs'
import '@/assets/style/global.css'
import messageAlert from '@/api/message_alert.js'
import GET_serverTime from '@/api/get_servertime.js'
var App = require(process.env.VUE_APP_TARGETAPP).default
Vue.config.productionTip = false;

var appCreate = function(){
  var UILangList = ['zh-CN','en'];
  var localeLangType = window.browserVersion.language;
  if(UILangList.indexOf(localeLangType)<0){
    var UIMainLangType = localeLangType.split('-')[0];
    if(UILangList.indexOf(UIMainLangType)>=0){
      localeLangType = UIMainLangType;
    }else{
      if(UIMainLangType === 'zh'){
        localeLangType = 'zh-CN';
      }else{
        localeLangType = 'en';
      }
    }
  }
  var eeoI18nData = {
    locale: localeLangType,
    messages: {}
  };
  moment.locale(eeoI18nData.locale);

  
  let langsDataSrc = process.env.VUE_APP_LANG + eeoI18nData.locale + '.js?v=' + (window.eeoBuildVersion || new Date().valueOf());
  requireJs([langsDataSrc],function(langData){
    eeoI18nData.messages[eeoI18nData.locale]=langData;
    const eeoI18n = new VueI18n(eeoI18nData);
    Vue.t = function () {
      return eeoI18n.t.apply(eeoI18n, arguments);
    };
    GET_serverTime('get').then(function(res){
      var serverTime = res.data.serverTime;
      var serverDTime = new Date().valueOf()-serverTime;
      window.AppRoot = new Vue({
        i18n:eeoI18n,
        render: (h) => h(App),
        data() {
          return {
            serverDTime:serverDTime,
            localTime:new Date().valueOf(),
            qs:qs,
            globalData:{
              localeLangType:localeLangType
            },
          };
        },
        computed:{
          serverShowTime(){
            return this.localTime - this.serverDTime
          },
          clientName(){
            var name = '';
            if(window.Vue.prototype.eeoHostType.isEEO){
              name = 'ClassIn'
            }else if(window.Vue.prototype.eeoHostType.isEEO){
              name = 'LiveClassroom'
            }
            return name
          }
        },
        methods: {
          serverTime() {
            return new Date().valueOf() - this.serverDTime;
          },
          pageLoading(status) {
            if (status === false ) {
              this.$indicator.close();
            } else {
              this.$indicator.open({
                spinnerType: 'fading-circle',
              })
              if (window.browserVersion.mobile) {
                this.$nextTick(() => {
                document.getElementsByClassName("mint-indicator-wrapper")[0].style.padding="30px"
                document.getElementsByClassName("circle-color-8")[0].style.width="60px"
                document.getElementsByClassName("circle-color-8")[0].style.height="60px"
                })  
              }
            }
          },
        },
        mounted() {
          setInterval(_=>{
            this.localTime = new Date().valueOf()
          },1000);
          ;(/iphone|ipod|ipad/i.test(navigator.appVersion)) && document.addEventListener('blur', (e) => {
            ['input', 'textarea'].includes(e.target.localName) && document.body.scrollIntoView(false)
          }, true);
        }
      }).$mount('#app');
    })
  })
}
appCreate();